import React from "react";
import styled from "styled-components";
import { nftMap } from "@/utils/abi";

function Spinner({ type, tokenId, children }) {

  const info = nftMap[type]

  return (
      <Card>
        <img className="poster" src={info.poster}/>
        <div className="collection">Jungle Squad</div>
        <div className="name">{info.name}</div>
        <div className="id">#{tokenId}</div>
        {children}
      </Card>
  )
}
export default Spinner;

const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 4px;
  margin-right: 30px;
  box-sizing: border-box;

  width: 168px;
  height: 246px;

  background: #161616;
  border-radius: 10px;
  
  .poster {
    width: 148px;
    height: 148px;
    display: block;
  }
  
  .collection {
    font-size: 16px;
    line-height: 22px;
    color: rgba(255, 255, 255, 0.6);
  }
  
  .name {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #FFFFFF;
  }
  
  .id {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #32DE86;
  }
`;


